export default __webpack_public_path__ + "static/media/ptr.29167c2d.jfif";